// ============================================================
// frontend/src/utils/clientHelpers.js
// ============================================================

/**
 * Retourne le nom affiché du client selon son type :
 *   - Professionnel (nom_societe renseigné) → "Société (Prénom Nom)"
 *   - Particulier                            → "Prénom Nom"
 */
export function formatNomClient(client) {
  if (!client) return '';
  if (client.nom_societe) return client.nom_societe;
  return [client.prenom, client.nom].filter(Boolean).join(' ').trim();
}
